import { marked } from 'marked';

const EMPTY_PARAGRAPH = /<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi;

/**
 * Render markdown to HTML for the chat text-part renderer.
 *
 * Output is NOT sanitized — bind it as a plain string to `[innerHTML]` so Angular
 * sanitizes at render time; never pass it through `bypassSecurityTrustHtml`.
 *
 * GFM + line-break extension enabled. Trailing empty `<p>` tags (common with the
 * `breaks: true` setting on inputs ending in blank lines) are stripped.
 */
export function processMarkdown(text: string): string {
  const html = String(marked.parse(text, { async: false, gfm: true, breaks: true }));
  return html.replace(EMPTY_PARAGRAPH, '');
}
